

































































































































import { Model, Vue } from 'vue-property-decorator'

import Component from 'vue-class-component'

import User from '@/store/modules/user'
import Recording from '@/store/modules/recording'
import Transcripts from '@/store/modules/transcripts'
import { getModule } from 'vuex-module-decorators'
import Translations from '@/store/modules/translations'
import Store from '@/store/index'

import api from '@/api/main'

import { AGE_OPTION_KIDS_VALUE, COLOR_VARIANT, TRANSCRIPTS_AGE } from '@/constants'

import {
  AGE_OPTIONS,
  GENDER_OPTIONS,
  ACCENT_OPTIONS,
  REGION_OPTIONS,
  LANGUAGE_OPTIONS,
  SECOND_LANGUAGE_OPTIONS
} from '@cfg/userDetailsForm.json'

import ApiException from '@/exceptions/ApiException'

// create tyepsafe accessor using getModule to access state of the User and Configuration from the store.
const user = getModule(User, Store)
const recording = getModule(Recording, Store)
const transcripts = getModule(Transcripts)
const translations = getModule(Translations) // Store accessor.

const TITLE_KEY = 'userDetailsTitleText'
const SESSION_INFO_KEY = 'userDetailsSessionText'
const LABELS_KEY = 'userDetailsFormLabelsText'
const NEXT_KEY = 'userDetailsNextText'

const UI_TEXT_TOAST_ERROR_TITLE = 'toastErrorErrorTitle'
const UI_TEXT_TOAST_ERROR_USER_CREATE = 'toastErrorUserCreate'

@Component
export default class UserDetailsForm extends Vue {
  @Model('change', { type: Boolean }) readonly checked!: boolean
  isPostingData = false

  ageGroup = null
  gender = null
  regionalAccent = null
  userRegion = null
  nativeLanguage = null
  secondLanguage = null

  nextButtonStateClass = 'w-10 mt-2 mb-2 font-size-large next-button'

  // fill the drop down options
  ages = AGE_OPTIONS
  genders = GENDER_OPTIONS
  accents = ACCENT_OPTIONS
  regions = REGION_OPTIONS
  languages = LANGUAGE_OPTIONS
  secondLanguages = SECOND_LANGUAGE_OPTIONS

  yourDetailsText = translations.getTranslations(TITLE_KEY)
  sessionText = translations.getTranslations(SESSION_INFO_KEY)
  formLabelsText = translations.getTranslations(LABELS_KEY)
  nextText = translations.getTranslations(NEXT_KEY)

  mounted () {
    user.updateIsValid(false)
  }

  // component method - call when the form is submit by the user.
  async submitUserDetails (event: Event) {
    console.log('submitUserDetails')
    // update the state with the new user details
    if (event) {
      event.preventDefault() // prevent page refresh on submit
    }
    const detailsToSubmit = {
      // eslint-disable-next-line @typescript-eslint/camelcase
      age_group: this.ageGroup ?? '',
      gender: this.ageGroup !== '<18' ? this.gender ?? '' : '',
      accent: this.ageGroup !== '<18' ? this.regionalAccent ?? '' : '',
      region: this.ageGroup !== '<18' ? this.userRegion ?? '' : '',
      // eslint-disable-next-line @typescript-eslint/camelcase
      native_language: this.ageGroup !== '<18' ? this.nativeLanguage ?? '' : '',
      // eslint-disable-next-line @typescript-eslint/camelcase
      second_language: this.secondLanguage ?? ''
    }
    this.isPostingData = true

    try {
      const response: Record<string, string> = await api.createUser(detailsToSubmit)

      transcripts.updateTranscriptionType(this.ageGroup === AGE_OPTION_KIDS_VALUE ? TRANSCRIPTS_AGE.KIDS : TRANSCRIPTS_AGE.DEFAULT)

      user.updateUserId(response.user_id)
      user.updateIsValid(true)
      user.updateAgeGroup(this.ageGroup ?? '')

      recording.updateRecordingId()

      this.routeToNextPage()
    } catch (apiError) {
      let toastMessageKey: string = UI_TEXT_TOAST_ERROR_USER_CREATE
      let toastColorVariant: string = COLOR_VARIANT.DANGER

      if (apiError instanceof ApiException) {
        toastMessageKey = apiError.toastMessage
        toastColorVariant = apiError.toastColor
      }

      this.$bvToast.toast(translations.getTranslations(toastMessageKey), {
        title: translations.getTranslations(UI_TEXT_TOAST_ERROR_TITLE),
        variant: toastColorVariant,
        solid: true
      })
    }

    this.isPostingData = false
  }

  // component method to route to the next page.
  routeToNextPage () {
    this.$router.push('/audio-check')
  }
}
